/**
 * Created by Vladislav on 25.09.2024.
 */

Placements.ENTRIES["repeatedQuests"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: 1,
    filter: function () {
        return cleverapps.environment.isMainScene()
            && Map2dLocation.currentLocation && Map2dLocation.currentLocation.quests && Map2dLocation.currentLocation.quests.isRepeatedQuestsAvailable();
    },

    action: function () {
        Map2dLocation.currentLocation.quests.runRepeatedQuests();
    },

    interval: cleverapps.config.debugMode ? "10 seconds" : "1 hour"
};

Placements.ENTRIES["runSpecialEnergyOffer"] = {
    type: Placements.FREE_FOCUS,

    filter: function () {
        return cleverapps.environment.isMainScene() && Map2dLocation.currentLocation
            && cleverapps.specialEnergyOffer && cleverapps.specialEnergyOffer.showPlacement;
    },

    action: function () {
        cleverapps.specialEnergyOffer.showPlacement = false;

        cleverapps.specialEnergyOffer.displayWindow();
    }
};

Placements.ENTRIES["locationStart"] = {
    type: Placements.FREE_FOCUS,
    priority: 2,
    delayFromStart: "1 minutes",

    filter: function () {
        return cleverapps.environment.isMainScene() && cleverapps.meta.getSelectedLocation().locationConfig.isMain && !cleverapps.config.demoMode;
    },

    action: function () {
        const pendingLocations = cleverapps.meta.listPendingLocations();
        if (pendingLocations.length) {
            cleverapps.meta.startLocation(pendingLocations[0]);
        }
    }
};

Placements.ENTRIES["locationFinish"] = {
    type: Placements.FREE_FOCUS,
    priority: 8,
    filter: function () {
        return cleverapps.environment.isMainScene() && cleverapps.meta.getSelectedLocation().isCompleted() && !cleverapps.config.demoMode;
    },

    action: function () {
        const location = cleverapps.meta.getSelectedLocation();

        cleverapps.focusManager.display({
            focus: `locationsFinished${location.locationId}`,
            action: function (f) {
                location.displayCompleted(f);
            }
        });
    }
};

Placements.ENTRIES["locationRemoveSilents"] = {
    type: Placements.FREE_FOCUS,
    priority: 6,
    filter: function () {
        return cleverapps.environment.isMainScene() && !cleverapps.config.demoMode;
    },

    action: function () {
        cleverapps.meta.removeSilents();
    }
};

Placements.ENTRIES["replaceOldLocation"] = {
    type: Placements.FREE_FOCUS,
    priority: 7,
    action: function () {
        cleverapps.meta.replaceOldLocation();
    }
};

Placements.ENTRIES["runCounterStages"] = {
    type: Placements.FREE_FOCUS,
    priority: 1,
    action: function () {
        if (Map2dLocation.currentLocation && Map2dLocation.currentLocation.showUpFinished && !Map2dLocation.currentLocation.counter.isActive()) {
            // do not run counter events if another free focus event wants to occur
            Map2dLocation.currentLocation.counter.setTimeout(() => {}, 50);
        }
    }
};

Placements.ENTRIES["runPixelPlanner"] = {
    type: Placements.FREE_FOCUS_MAIN,

    filter: function () {
        return Map2dLocation.currentLocation && Map2dLocation.currentLocation.friendPixelsPlanner;
    },
    action: function () {
        Map2dLocation.currentLocation.friendPixelsPlanner.planFriendPixels();
    }
};

Placements.ENTRIES["interstitialInactive"] = {
    type: Placements.FREE_FOCUS,
    priority: 0,
    filter: function () {
        return InterstitialHelper.checkLastFocus()
            && cleverapps.adsLimits.state(AdsLimits.TYPES.INTERSTITIAL) === AdsLimits.STATE_READY;
    },

    action: function () {
        cleverapps.focusManager.display({
            focus: "showInterstitialPlacement",
            action: function (f) {
                cleverapps.rewardedAdsManager.showInterstitial({
                    limit: AdsLimits.TYPES.INTERSTITIAL,
                    placement: AdsLimits.TYPES.INTERSTITIAL_INACTIVE
                }, f);
            }
        });
    },

    delayFromStart: "3 minutes"
};

InterstitialHelper = {
    checkLastFocus: function () {
        const focus = cleverapps.focusManager.lastFocus;
        if (!focus) {
            return false;
        }

        return focus.startsWith("missionCompleted")
            || (InterstitialHelper.ALLOWED_FOCUSES[cleverapps.config.subtype] || InterstitialHelper.ALLOWED_FOCUSES[cleverapps.config.type] || []).indexOf(focus) !== -1;
    },

    ALLOWED_FOCUSES: {
        merge: ["onLevelUp", "FinishQuest", "ExitExpeditionIconClicked",
            "openChestWindow", "updateBuildPassUnit", "GiveRuinReward",
            "ConfirmSpeedUpWindowLock", "StartUnitDialogue", "StartUnitGreeting"]
    }
};